<template>
    <a-popover :title="false" destroyTooltipOnHide @visibleChange="handleVisibleChange" placement="topLeft" :overlay-style="{ padding: 0 }">
        <div slot="content">
            <colorSelect style="padding: 10px 10px 0 10px" v-if="colorShow" @change="handleColorChange" v-model="dataInfo.colour" />
            <div class="flex x-left button-gather">
                <a-tooltip destroyTooltipOnHide>
                    <template slot="title">
                        {{ $t('program.edit_unit' /* 编辑单元 */) }}
                    </template>
                    <a-button @click="$emit('edit')" icon="edit" style="color: #3661c3"></a-button>
                </a-tooltip>
                <a-tooltip destroyTooltipOnHide>
                    <template slot="title">
                        {{ $t('program.meeting_schedule_management' /* 会议日程管理 */) }}
                    </template>
                    <a-button @click="$emit('session')" icon="credit-card" style="color: #7a5cbe"></a-button>
                </a-tooltip>
                <a-tooltip destroyTooltipOnHide>
                    <template slot="title">
                        {{ $t('web.delete' /* 删除 */) }}
                    </template>
                    <a-button icon="delete" @click="handleDeleteEvent" style="color: #e01741"></a-button>
                </a-tooltip>
                <!-- <a-tooltip destroyTooltipOnHide>
                    <template slot="title">
                        改色
                    </template> -->
                <a-button @click="colorShow = true" icon="bg-colors" style="color: #e8b524"></a-button>
                <!-- </a-tooltip> -->
                <a-tooltip destroyTooltipOnHide>
                    <template slot="title">
                        {{ $t('program.export_session' /* 导出Session日程 */) }}
                    </template>
                    <a-button icon="export" style="color: #e07a22"></a-button>
                </a-tooltip>
            </div>
        </div>
        <div
            @click="$emit('session')"
            class="card-item-box"
            :style="{
                backgroundColor: dataInfo.colour,
                color: dataInfo.colour ? '#fff' : ''
            }"
        >
            <div class="card-header">
                {{ dataInfo.abstract_title }}
                <div
                    class="circle flex y-center x-center"
                    v-if="dataInfo.count_son > 0"
                    :style="{
                        color: dataInfo.colour,
                        border: '2px solid ' + dataInfo.colour
                    }"
                >
                    {{ dataInfo.count_son }}
                </div>
            </div>
            <div class="content" v-if="dataInfo.class_cnname || dataInfo.live_notes">
                <div v-if="dataInfo.class_cnname">{{ $t('program.topic_forum' /* 所属专题分论坛： */) }}{{ dataInfo.class_cnname }}</div>
                <div class="flex x-left" v-if="dataInfo.live_notes">
                    {{ $t('program.batch_live_label_live_notes' /* 直播备注 */) }}：
                    <div v-html="dataInfo.live_notes"></div>
                </div>
            </div>
        </div>
    </a-popover>
</template>

<script>
import colorSelect from '@/components/color-select.vue';
export default {
    name: 'CardItem',
    components: {
        colorSelect
    },
    props: {
        dataInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            colorShow: false
        };
    },
    methods: {
        handleVisibleChange(e) {
            if (!e) {
                this.colorShow = e;
            }
        },
        // 颜色改变
        handleColorChange(color) {
            this.colorShow = false;
            this.$request.post({ url: 'setProcessSessionColor', data: { customid: this.dataInfo.id, color } }).then(res => {
                this.$message.success(this.$route.params.lang == 'cn' ? '删除成功' : 'Delete success');
                this.$emit('change-color', color);
            });
        },
        // 删除session信息
        handleDeleteEvent() {
            this.$confirm({
                title: this.$t('web.tips' /* 温馨提示 */),
                content: this.$t(
                    'program.delete_session',
                    { session: this.$route.params.lang == 'cn' ? this.dataInfo.abstract_title : this.dataInfo.abstract_title_en } /* 确认删除【{session}】该Session吗？ */
                ),
                onOk: () => {
                    this.$request.post({ url: 'deleteProgramSession', data: { cid: this.dataInfo.id } }).then(res => {
                        this.$message.success(this.$route.params.lang == 'cn' ? '删除成功' : 'Delete success');
                        this.$emit('remove');
                    });
                }
            });
        }
    },
    mounted() {
        // 因为popover元素默认绑定在了最外边，所以无法通过css穿透去设置
        const style = document.createElement('style');
        style.textContent = `
              .ant-popover .ant-popover-inner-content {
                padding : 4px;
              }
            `;
        document.head.appendChild(style);
    }
};
</script>

<style scoped lang="less">
.button-gather {
    button {
        border: none;
        padding: 6px;
    }
}
.card-item-box {
    width: 100%;
    position: relative;
    border-radius: 7px;
    border-top-left-radius: 0;
    cursor: pointer;
    border: 1px solid transparent;
    margin-top: 5px;
    background-color: #eaf4ff;
    color: #000;
    .card-header {
        border-top-right-radius: 7px;
        padding: 8px 10px;
        font-weight: 500;
        position: relative;
        .circle {
            position: absolute;
            right: -8px;
            top: -8px;
            width: 18px;
            height: 18px;
            font-size: 12px;
            font-weight: bold;
            border-radius: 18px;
            background-color: #fff;
            z-index: 9;
        }
    }
    .content {
        background-color: rgba(0, 0, 0, 0.05);
        & > div {
            padding: 5px 10px;
        }
    }
}
</style>